var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.items),function(item){return _c('menu-item',{key:item.text,attrs:{"item":item}})}))}
var staticRenderFns = []

export { render, staticRenderFns }